import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { styledWithTheme } from "../context";
export var rootStyles = {
  '--st-group-button-width': '1px',
  '--st-group-button-focus-width': '2px',
  '--st-group-button-stacked-width': '0px'
};
export var ToggleButtonGroupBase = styledWithTheme('fieldset')(function (_ref) {
  var _ref2;

  var flexDirection = _ref.flexDirection,
      theme = _ref.theme;
  return _ref2 = {
    display: 'flex',
    flexDirection: "".concat(flexDirection),
    border: 'none'
  }, _defineProperty(_ref2, "& > button:not(:first-of-type)", _objectSpread(_objectSpread({}, flexDirection === 'row' && {
    borderLeftWidth: 'var(--st-group-button-width)'
  }), flexDirection === 'column' && {
    borderTopWidth: 'var(--st-group-button-stacked-width)'
  })), _defineProperty(_ref2, "& > button:not(:last-of-type)", _objectSpread({}, flexDirection === 'row' && {
    borderRightWidth: 'var(--st-group-button-width)'
  })), _defineProperty(_ref2, "& > button:focus", _objectSpread(_objectSpread({
    zIndex: 1,
    boxShadow: "0 0 0 1px ".concat(theme.selectors.color('neutral0'))
  }, flexDirection === 'column' && {
    borderTopWidth: 'var(--st-group-button-focus-width)'
  }), {}, {
    '&:not(:first-of-type)': {
      borderLeftWidth: 'var(--st-group-button-focus-width)'
    },
    '&:not(:last-of-type)': {
      borderRightWidth: 'var(--st-group-button-focus-width)'
    }
  })), _ref2;
});